/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
  sortCaret,
  headerSortingClasses,
} from "../../../_helpers";
import { CustomersDebtTable } from "../../../../app/modules/ECommerce/pages/customers/customers-table/customer-debt-table/CustomersDebtTable";
import { CustomersDebtTableProvider } from "../../../../app/modules/ECommerce/pages/customers/customers-table/customer-debt-table/CustomersDebtTableUIContext";
import { CustomersDebtFilter } from "../../../../app/modules/ECommerce/pages/customers/customers-filter/CustomersDebtFilter";
import { MoneyFormatter } from "../../../../app/modules/formatters/CustomFormatters";

export function CustomersDebtAmountWidget({ className }) {
  const customercodeColumn = {
    dataField: "customercode",
    text: "System id",

    sortCaret: sortCaret,
    headerSortingClasses,
  };

  const customerNameColumn = {
    dataField: "customerName",
    text: "Name",

    sortCaret: sortCaret,
    headerSortingClasses,
  };

  const amountColumns = [
    customerNameColumn,
    customercodeColumn,
    {
      dataField: "customerSum",
      text: "Amount",
      formatter: MoneyFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "cutomerDeleySum",
      text: "Aggregate past due amount",
      formatter: MoneyFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "cutomerDeleyDays",
      text: "Aggregate Days In Deley",

      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
  ];

  return (
    <>
      {/* begin::Base Table Widget 6 */}
      {/* <InvoiceFileUpload /> */}
      <div className={`card card-custom ${className}`}>
        {/* begin::Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              Past due by customer
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              Includes Unknown customers
            </span>
          </h3>
        </div>
        {/* end::Header */}
        <div className="container">
          <CustomersDebtTableProvider>
            <CustomersDebtFilter />
            <CustomersDebtTable
              columns={amountColumns}
              sortBy="cutomerDeleySum"
            />
          </CustomersDebtTableProvider>
        </div>
        {/* begin::Body */}

        {/* end::Body */}
      </div>

      <div className={`card card-custom ${className}`}>
      </div>
      {/* end::Base Table Widget 6 */}
    </>
  );
}
